
import { Component, Prop, Vue } from 'vue-property-decorator';

import { getStockCheckList } from '@/api/stock';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'StockCheckChildrenList'
})
export default class extends Vue {
  // 当前层级的名称列表
  @Prop({
    type: Array,
    default: () => []
  })
  list!: any[];

  // 当前列表的父级库存 id（用于懒加载下级）
  @Prop({
    type: [String, Number],
    default: ''
  })
  pid!: any;

  // 展开行：懒加载下级名称（盘点列表接口传 pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.id === row.id);
    if (expanded && !row.childrenx) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: row.id,
      page: 1,
      size: 9999
    };
    getStockCheckList(params)
      .then((res: any) => {
        const data = res.data;
        this.$set(row, 'childrenx', data && data.list ? data.list : []);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 保存盘点库存（冒泡至父级统一处理）
  private emitAddCheck(nameRow: any, modelRow: any) {
    this.$emit('add-check', nameRow, modelRow);
  }

  private large(val: any, index?: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
